import { Component, OnInit } from '@angular/core';
import { SurveyWindowNG, SurveyNG, ReactSurveyModel } from 'survey-angular'

@Component({
  selector: 'app-survey',
  templateUrl: './survey.component.html'
})
export class SurveyComponent implements OnInit {
  surveyJSON = {
    pages: [
     {
      name: 'Welcome',
      elements: [
       {
        type: 'text',
        name: 'question1',
        title: 'Name'
       },
       {
        type: 'text',
        name: 'question2',
        title: 'Email'
       },
       {
        type: 'text',
        name: 'question3',
        title: 'Three Letter Company Code'
       },
       {
        type: 'text',
        name: 'question4',
        title: 'Five Digit Office Number'
       }
      ],
      title: 'Welcome',
      description: 'Assessment Introduction'
     },
     {
      name: 'Organization',
      elements: [
       {
        type: 'radiogroup',
        name: 'question5',
        title: 'How many employees does your franchise have?',
        choices: [
         {
          value: '1',
          text: '1 - 10'
         },
         {
          value: '11',
          text: '11 - 20'
         },
         {
          value: '21',
          text: '> 20'
         }
        ]
       },
       {
        type: 'radiogroup',
        name: 'question6',
        title: 'How many tax returns do you prepare each year?',
        choices: [
         {
          value: '1',
          text: '1 - 999'
         },
         {
          value: '1000',
          text: '1,000 - 10,000'
         },
         {
          value: '10001',
          text: '> 10,000'
         }
        ]
       }
      ],
      title: 'Organization',
      description: 'Supporting business information'
     },
     {
      name: 'Business_Operations',
      elements: [
       {
        type: 'radiogroup',
        name: 'question7',
        title: 'Are you a Company Owned Operation (COO)?',
        choices: [
         {
          value: 'true',
          text: 'Yes'
         },
         {
          value: 'false',
          text: 'No'
         }
        ]
       },
       {
        type: 'radiogroup',
        name: 'question8',
        title: 'Are you a stand alone location?',
        choices: [
         {
          value: 'true',
          text: 'Yes'
         },
         {
          value: 'false',
          text: 'No'
         }
        ]
       },
       {
        type: 'radiogroup',
        name: 'question9',
        visibleIf: '{question8} = "false"',
        title: 'Are you located within a Wal-Mart?',
        choices: [
         {
          value: 'true',
          text: 'Yes'
         },
         {
          value: 'false',
          text: 'No'
         }
        ]
       }
      ],
      title: 'Business Operations',
      description: 'Store Type'
     }
    ],
    questionTitleLocation: 'left',
    showProgressBar: 'top'
   };

  constructor() { }

  ngOnInit() {
    const survey = new ReactSurveyModel(this.surveyJSON);
    survey.onComplete.add(this.sendDataToServer);
    SurveyNG.render('surveyElement', {model:survey});
  }

  sendDataToServer(survey) {
    const resultAsString = JSON.stringify(survey.data);
    alert(resultAsString); // send Ajax request to your web server.
  }

}
